import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { CRSFtokenInterceptor } from "./csrftoken.interceptor";
import { ErrorInterceptor } from './error.interceptor';
import { SpinnerInterceptor } from "./spinner.interceptor";
import { PdaInterceptor } from "src/app/pda/utils/pda.interceptor";

export const interceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CRSFtokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: PdaInterceptor, multi: true },
];
